<template>
  <PdfSingleViewer
    :zoomValue="zoomValue"
    :client="true"
    @changeZoomValue="handleChangeZoomValue"
    :zoom="true"
    :zoomMax="5"
    :shown="true"
    :pdflibSrc="pdflibSrc"
    :pdfWorkerSrc="pdfWorkerSrc"
    :cmapUrl="cmapUrl"
    :pdfUrl="pdfUrl"
    :withCredentials="withCredentials"
    :ref="`pdfSingleViewer${id}`"
  ></PdfSingleViewer>
</template>
<script>
import { PdfSingleViewer } from '@tsign/tsign-ui'
export default {
  data() {
    return {
      zoomValue: 1,
      pdflibSrc: 'https://asset.esign.cn/apps/esign-pdf/2.3.2/pdf.js',
      pdfWorkerSrc: 'https://asset.esign.cn/apps/esign-pdf/2.3.2/pdf.worker.min.js',
      cmapUrl: 'https://asset.esign.cn/apps/esign-pdf/fonts/',
    }
  },
  components: {
    PdfSingleViewer,
  },
  methods: {
    handleChangeZoomValue(zv) {
      this.zoomValue = zv
    },
  },
  props: {
    withCredentials: Boolean,
    pdfUrl: String,
    id: Number,
  },
}
</script>
